import React from "react";

// Wordmark + dome icon logo. Uses the dome asset in place of the SVG mark.
export default function Logo({ size, height, showText = true }) {
  const s = size || height || 40;
  return (
    <div className="flex items-center gap-3">
      <div
        style={{ width: s, height: s }}
        className="relative flex items-center justify-center shrink-0"
      >
        <img
          src="/assets/dome.png"
          alt="Masjid Suite"
          className="w-full h-full object-contain"
          style={{
            imageRendering: "-webkit-optimize-contrast",
            filter: "drop-shadow(0 2px 4px rgba(14,36,8,0.15))",
          }}
          draggable={false}
        />
      </div>
      {showText && (
        <div className="leading-tight">
          <div className="font-display text-[16px] font-semibold text-[#0e2408] tracking-tight">
            Masjid Suite
          </div>
          <div className="text-[9px] tracking-[0.22em] uppercase text-[#a8862f] font-semibold">
            by Harmonia
          </div>
        </div>
      )}
    </div>
  );
}
